module.exports = __webpack_public_path__ + "static/cosycolour6-a9c6324a89bcb84bb1352c3008ec45fb.png";